import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <img src="/logo.png" alt="Manthrakodi" style={{ height: 50, marginBottom: 8 }} />
          <p>Admin Panel</p>
        </div>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}>
            📊 Dashboard
          </NavLink>
          <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}>
            👥 Users
          </NavLink>
          <NavLink to="/admin/wallets" className={({ isActive }) => isActive ? 'admin-nav-link active' : 'admin-nav-link'}>
            💰 Wallets
          </NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <p className="admin-email">{user?.email}</p>
          <button className="admin-logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
